import { ArrowDownLeft, ArrowDownToLine, ArrowUpRight, FileDown } from "lucide-react";
import { toast } from "sonner";
import { downloadReceipt, errMsg, fmtBtc, fmtUsd } from "@/lib/api";

const STATUS = {
  completed: "bg-emerald-500/10 text-emerald-400",
  pending: "bg-amber-500/10 text-amber-400",
  failed: "bg-red-500/10 text-red-400",
  rejected: "bg-red-500/10 text-red-400",
};
const TYPES = {
  buy: { l: "Buy", c: "text-emerald-400", I: ArrowDownLeft },
  sell: { l: "Sell", c: "text-red-400", I: ArrowUpRight },
  withdraw: { l: "Withdraw", c: "text-[#F7931A]", I: ArrowDownToLine },
};

const ReceiptBtn = ({ id }) => (
  <button onClick={() => downloadReceipt(id).then(() => toast.success("Receipt downloaded")).catch((e) => toast.error(errMsg(e)))}
    data-testid={`receipt-download-${id}`} title="Download receipt"
    className="rounded-lg border border-[#212638] p-1.5 text-[#94A3B8] transition-colors hover:bg-[#1C2030] hover:text-[#F7931A]">
    <FileDown size={14} />
  </button>
);

const Row = ({ t }) => {
  const ty = TYPES[t.type] || TYPES.buy;
  return (
    <tr className="border-t border-[#212638] transition-colors hover:bg-[#1C2030]" data-testid={`transaction-row-${t.tx_id}`}>
      <td className="py-3"><span className={`inline-flex items-center gap-1.5 font-semibold ${ty.c}`}><ty.I size={14} />{ty.l}</span></td>
      <td className="py-3 font-mono">{t.type === "withdraw" ? "—" : fmtBtc(t.btc_amount)}</td>
      <td className="py-3 font-mono">{fmtUsd(t.usd_amount)}</td>
      <td className="hidden py-3 font-mono text-[#94A3B8] sm:table-cell">{t.fee_usd != null ? fmtUsd(t.fee_usd) : "—"}</td>
      <td className="hidden py-3 text-xs text-[#94A3B8] md:table-cell">{t.method}</td>
      <td className="hidden py-3 font-mono text-[#94A3B8] xl:table-cell">{t.btc_price ? fmtUsd(t.btc_price) : "—"}</td>
      <td className="py-3"><span className={`rounded-full px-2.5 py-1 text-xs font-semibold capitalize ${STATUS[t.status] || STATUS.pending}`}>{t.status}</span></td>
      <td className="hidden py-3 text-xs text-[#94A3B8] lg:table-cell">{new Date(t.created_at).toLocaleString()}</td>
      <td className="py-3 text-right">{t.status !== "failed" && <ReceiptBtn id={t.tx_id} />}</td>
    </tr>
  );
};

export const TxTable = ({ items }) => (
  <div className="overflow-x-auto" data-testid="transaction-history-table">
    {items.length === 0 ? (
      <p className="py-10 text-center text-sm text-[#64748B]" data-testid="transactions-empty">No transactions yet.</p>
    ) : (
      <table className="w-full text-sm">
        <thead>
          <tr className="text-left text-xs uppercase tracking-[0.15em] text-[#64748B]">
            <th className="pb-3 font-semibold">Type</th><th className="pb-3 font-semibold">BTC</th>
            <th className="pb-3 font-semibold">USD</th><th className="hidden pb-3 font-semibold sm:table-cell">Fee</th>
            <th className="hidden pb-3 font-semibold md:table-cell">Method</th>
            <th className="hidden pb-3 font-semibold xl:table-cell">Rate</th>
            <th className="pb-3 font-semibold">Status</th><th className="hidden pb-3 font-semibold lg:table-cell">Date</th>
            <th className="pb-3 text-right font-semibold">Receipt</th>
          </tr>
        </thead>
        <tbody>{items.map((t) => <Row key={t.tx_id} t={t} />)}</tbody>
      </table>
    )}
  </div>
);
